import React from 'react';
import { SideScrollStyled } from './SideScroll.styles';

export class SideScroll extends React.Component<React.HTMLAttributes<HTMLDivElement> & { sideScrollSpeed: number, hideScrollBar?: boolean }> {
  private ref = React.createRef<HTMLDivElement>();

  private sideScroll = (e: WheelEvent) => {
    if (e.shiftKey || e.ctrlKey || e.metaKey || e.deltaX || !e.deltaY)
      return;
    
    const target = e.currentTarget as HTMLDivElement;
    if (target) {
      e.preventDefault();
      target.scrollLeft += (e.deltaY * (e.deltaMode ? this.props.sideScrollSpeed : 1));
    }
  }

  componentDidMount = () => {
    this.ref.current?.addEventListener('wheel', this.sideScroll, { passive: false });
  };

  componentWillUnmount = () => {
    this.ref.current?.removeEventListener('wheel', this.sideScroll);
  };

  public render() {
    const { children, sideScrollSpeed, ...divProps } = this.props;
    return (
      <SideScrollStyled {...divProps} ref={ this.ref }>
        {children}
      </SideScrollStyled>
    );
  }
}
